export default {
  // 新增消防打卡
  insertPaFireClockin: '/ygsjzs/paFireClockin/insertPaFireClockin',
  // 物理删除消防打卡
  deleteDataPaFireClockin: '/ygsjzs/paFireClockin/deleteDataPaFireClockin',
  // 查询消防打卡详情
  selectPaFireClockinByClockId: '/ygsjzs/paFireClockin/selectPaFireClockinByClockId',
  // 分页查询消防打卡列表
  selectPaFireClockinByPage: '/ygsjzs/paFireClockin/selectPaFireClockinByPage'

}
